import ShopType from "@/enum/ShopType";
import { appKeyLoginShopTypes } from "@/utils/ShopUtils";

function getPrefix() {
    return "V2_";

    let prefix = "V2_";

    if (import.meta.env.MODE === "testServer") {
        prefix = "V2TEST_";
    }

    return prefix;
}

export const AppKeyLoginPrefix = "/appKeyLogin";

/**
 * 获取对应店铺类型的登录授权链接
 */
export default function getAuthShopUrl(shopType: ShopType) {
    const prefix = getPrefix();

    const search = new URLSearchParams();

    if (appKeyLoginShopTypes.includes(shopType)) {
        return `${AppKeyLoginPrefix}?shopType=${shopType}`;
    }

    switch (shopType) {
        case ShopType.TAOBAO: {
            search.set("client_id", "12260155");
            search.set("response_type", "code");
            search.set("redirect_uri", `https://tb.fahuoyi.com/oauth/callback/taobao/router`);

            search.set("state", `${prefix}login`);

            return `https://oauth.taobao.com/authorize?${search.toString()}`;
        }

        case ShopType.ALIBABA: {
            search.set("client_id", "1024869");
            search.set("site", "1688");
            search.set("redirect_uri", "https://tb.fahuoyi.com/oauth/callback/alibaba/router");

            search.set("state", `${prefix}login`);

            return `https://auth.1688.com/oauth/authorize?${search.toString()}`;
        }

        case ShopType.PINDUODUO: {
            search.set("client_id", "01b3a578f733447daccf6c228fe9f075");
            search.set("response_type", "code");
            search.set("redirect_uri", "https://pdd.fahuoyi.com/oauth/callback/pinduoduo/router");

            search.set("state", `${prefix}login`);

            return `https://fuwu.pinduoduo.com/service-market/auth?${search.toString()}`;
        }

        case ShopType.KTT: {
            search.set("client_id", "ae398f9b08d949c1b22ff4b3ad607dee");

            search.set("redirect_uri", "https://pdd.fahuoyi.com/oauth/callback/ktt/router");

            search.set("state", `${prefix}login`);

            return `https://oauth.pinduoduo.com/authorize/ktt?${search.toString()}`;
        }

        case ShopType.DOUDIAN: {
            search.set("service_id", "4");

            search.set("state", `${prefix}login`);

            /** 引流活动 */
            search.set("from", "yinliu");

            return `https://fuwu.jinritemai.com/authorize?${search.toString()}`;
        }

        case ShopType.DOUDIAN_IOP: {
            search.set("service_id", "20486");

            search.set("state", `${prefix}login`);

            search.set("from", "yinliu");

            return `https://fuwu.jinritemai.com/authorize?${search.toString()}`;
        }

        case ShopType.KWAI: {
            search.set("app_id", "ks649644246481934560");

            search.set("response_type", "code");

            search.set(
                "scope",
                "user_info,merchant_user,merchant_item,merchant_order,merchant_refund,merchant_logistics,merchant_servicemarket",
            );

            search.set("redirect_uri", "https://other.fahuoyi.com/oauth/callback/kwai/router");

            search.set("state", `${prefix}login`);

            return `https://open.kwaixiaodian.com/oauth/authorize?${search.toString()}`;
        }

        case ShopType.KWAI_DROPSHIP: {
            search.set("app_id", "ks680887970243211456");

            search.set("response_type", "code");

            search.set(
                "scope",
                "merchant_comment,merchant_dropshipping,merchant_logistics,merchant_order,merchant_refund,merchant_servicemarket,merchant_user,user_info",
            );

            search.set("redirect_uri", "https://other.fahuoyi.com/platform/login/oauth/kwai_dropship");

            search.set("state", `${prefix}login`);

            return `https://open.kwaixiaodian.com/oauth/authorize?${search.toString()}`;
        }

        case ShopType.WEIDIAN: {
            search.set("appkey", "642041");

            search.set("isH5", "false");

            search.set("response_type", "code");

            search.set("redirect_uri", "https://other.fahuoyi.com/oauth/callback/weidian/router");

            search.set("sign", "e7a33b9edd0c38641aee08e086a44d3c");

            search.set("state", `${prefix}login`);

            return `https://oauth.open.weidian.com/oauth2/authorize?${search.toString()}`;
        }

        case ShopType.MOGUJIE: {
            search.set("app_key", "100189");

            search.set("response_type", "code");

            search.set("redirect_uri", "https://other.fahuoyi.com/oauth/callback/mogujie/router");

            search.set("state", `${prefix}login`);

            return `https://oauth.mogujie.com/authorize?${search.toString()}`;
        }

        case ShopType.WEIMOB_EC: {
            search.set("clientId", "4D180EFF09FAC962AC12A65F001010FE");

            search.set("redirectUrl", "https://other.fahuoyi.com/oauth/callback/weimob_ec/router");

            search.set("extParameter", `${prefix}login`);

            return `https://console.weimobcloud.com/auth?${search.toString()}`;
        }

        case ShopType.XIAOHONGSHU: {
            search.set("appId", "d715fb6e4cfc44539048");

            search.set("redirectUri", "https://other.fahuoyi.com/oauth/callback/xiaohongshu/router");

            search.set("state", `${prefix}login`);

            return `https://ark.xiaohongshu.com/ark/authorization?${search.toString()}`;
        }

        case ShopType.ALI_C2M: {
            search.set("client_id", "2455380");

            search.set("site", "c2m");

            search.set("redirect_uri", "https://tb.fahuoyi.com/oauth/callback/ali_c2m/router");

            search.set("state", `${prefix}login`);

            return `https://auth.1688.com/auth/authorize.htm?${search.toString()}`;
        }

        case ShopType.DUXIAODIAN: {
            search.set("client_id", "zQAptve727F7h7RiVzeZrcet");

            search.set("response_type", "code");

            search.set("confirm_login", "1");

            search.set("scope", "bmp_order bmp_product");

            search.set("redirect_uri", "https://other.fahuoyi.com/oauth/callback/duxiaodian/router");

            search.set("state", `${prefix}login`);

            return `https://openapi.baidu.com/oauth/2.0/authorize?${search.toString()}`;
        }

        /** 目前京东分销与京东的授权逻辑一样 */

        case ShopType.JD:
        case ShopType.JD_PURCHASE: {
            search.set("app_key", "F7C226A97CA6AA49165D8636D910D63B");

            search.set("response_type", "code");

            search.set("redirect_uri", "https://jd.fahuoyi.com/platform/login/oauth/jd");

            search.set("state", `${prefix}login`);

            search.set("scope", "snsapi_base");

            return `https://open-oauth.jd.com/oauth2/to_login?${search.toString()}`;
        }

        case ShopType.YOUZAN:
            return "https://qw15p3s8hv.feishu.cn/wiki/wikcnO2sUKDbDB3Jftxyc8sAyTf";

        case ShopType.SUNING:
            search.set("client_id", "6214a2afd0309434f2039d84d9346827");

            search.set("response_type", "code");

            search.set("itemcode", "3968");

            search.set("redirect_uri", "https://other.fahuoyi.com/oauth/callback/suning/router");

            search.set("state", `${prefix}login`);

            return `http://open.suning.com/api/oauth/authorize?${search.toString()}`;

        case ShopType.DOUDIAN_SUPPLIER:
            search.set("service_id", "23136");

            search.set("state", `${prefix}login`);

            search.set("from", "yinliu");

            return `https://fuwu.jinritemai.com/authorize?${search.toString()}`;
        default:
            return "";
    }
}
